import React from "react";
import { Avatar as MUIAvatar } from "@mui/material";

export default function Avatar({ role }) {
  const imageUrl = role === "user" ?  "": require("../../../assets/img/logo.png");

  return <MUIAvatar src={imageUrl} sx={{ mr: "5px" }} />;
}